// Example Params-
// route: '/admin/brandhub#/templates/edit-page/:templatePageId'
// routeParams: { templatePageId: 5 }

// Output-
// '/admin/brandhub#/templates/edit-page/5'

type SubstituteRouteParamParams = {
  route: string,
  routeParams: { [key: string]: number },
}

const substituteRouteParams = (params: SubstituteRouteParamParams) => {
  const { route, routeParams } = params

  let routeWithSubstitutions = route

  Object.entries(routeParams).forEach((redirectParam) => {
    const [key, value] = redirectParam

    const regex = new RegExp(`:${key}`)
    routeWithSubstitutions = routeWithSubstitutions.replace(regex, `${value}`)
  })

  return routeWithSubstitutions
}

export default substituteRouteParams
